import React from 'react'
import { useNavigate } from 'react-router-dom'
import ArrowLeftMinor from '../../img/icons/navigation/arrow-left.svg'

const GoBackPageNavigation = ({content, onBack}) => {
	const navigate = useNavigate()
	
	// useEffect(() => {
	// 	const handleKeyDown = (event) => {
	// 		if (event.key === "Backspace") {
	// 			goBack()
	// 		}
	// 	}
	// 	document.addEventListener("keydown", handleKeyDown)
	// 	return () => {
	// 		document.removeEventListener("keydown", handleKeyDown)
	// 	}
	// }, [])
	
  const goBack = () => {
    if (onBack) {
      onBack()
    } else {
      navigate(-1)
    }
  }

	return (
		<div style={{display: 'flex', alignItems: 'center'}}>
      <div
        style={{
          marginRight: '10px',
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer',
        }}
		      onClick={goBack}
      >
        <div
          style={{
            width: '25px',
            height: '25px',
            backgroundColor: 'transparent',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
	          marginRight: 10
          }}
        >
          <img
            style={{cursor: 'pointer', width: '18.6px', height: '18.6px'}}
            src={ArrowLeftMinor}
            alt={'ArrowLeftMinor'}
          />
        </div >
	      
	      {content}
	      
      </div >
    </div >
	)
}

export default GoBackPageNavigation